import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import TVChannelItemBlockData from 'Models/Content/TVChannelItemBlockData';
import {getImageProps} from 'app/utilities/ImageProps';
import {SwiperSlide} from 'swiper/react';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';

type TVChannelSlideProps = {
  item: TVChannelItemBlockData;
  context: IEpiserverContext;
};

const TVChannelSlide = ({item, context}: TVChannelSlideProps) => (
  <>
    <div className='TVChannelsListBlock__swiper__image-wrap'>
      <Image className='TVChannelsListBlock__swiper__image-wrap__image' {...getImageProps(item.image, context)} />
    </div>
    <span className='TVChannelsListBlock__swiper__title'>{item.title.value}</span>
  </>
);

export default TVChannelSlide;
